<div class="modal-header d-flex align-items-center justify-content-center">
  <img src="../../../../../assets/img/sleep.svg" alt="" height="24" />
  <h3 class="modal-title ps-2">{{ 'inactiveTitle' | translate }}</h3>
</div>
<div class="modal-body d-flex flex-column justify-content-center align-items-center">
  <div>{{ 'inactiveMessage' | translate: { SECONDS: countdown } }}</div>
</div>
